import { Box, CircularProgress, Grid } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AddButton } from '../components/AddButton'
import { CustomExplain } from '../components/CustomExplain'
import { CustomPaper } from '../components/CustomPaper'
import { CustomTitle } from '../components/CustomTitile'
import { Footer } from '../components/Footer'
import { ModalConfirmDialog } from '../components/ModalConfirmDialog'
import { PhraseList } from '../components/PhraseList'
import { loadStatus } from '../constants/loadStatus'
import { useAuth } from '../hooks/useAuth'
import { useC301PhraseGet } from '../hooks/useC301PhraseGet'
import { useC302PhraseAdd } from '../hooks/useC302PhraseAdd'
import { useC303PhraseDelete } from '../hooks/useC303PhraseDelete'
import type { PhraseInfo } from '../interfaces/PhraseIf'
import { LanguageContext } from '../util/LanguageContext'
import { SideMenu } from './SideMenu'

// 優先単語画面
export const Phrase = () => {
  // hooks
  const auth = useAuth()
  const [searchParams] = useSearchParams()
  const c301 = useC301PhraseGet()
  const c302 = useC302PhraseAdd()
  const c303 = useC303PhraseDelete()
  // 文字列変換用
  const translation = useContext(LanguageContext)
  // ダイアログ
  const [openDialog, setOpenDialog] = useState(false)
  const [errorDialog, setErrorDialog] = useState('')
  // 優先単語配列
  const [phrases, setPhrases] = useState<PhraseInfo[]>([])
  // ローディングステータス監視
  useEffect(() => {
    if (
      c301.loading === loadStatus.LOADING ||
      c302.loading === loadStatus.LOADING ||
      c303.loading === loadStatus.LOADING
    ) {
      auth.setIsDisable(true)
    } else {
      auth.setIsDisable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [c301.loading, c302.loading, c303.loading])

  // 優先単語追加ハンドラ
  const phraseAddHandler = async (inputValue: string) => {
    const result = await c302.execPhraseAdd(auth.deviceId, inputValue)
    if (result.success) {
      const result = await c301.execPhraseGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setPhrases(result.info!)
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }
  // 優先単語削除ハンドラ
  const phraseDelHandler = async (inputValue: string) => {
    const result = await c303.execPhraseDelete(auth.deviceId, inputValue)
    if (result.success) {
      const result = await c301.execPhraseGet(auth.deviceId)
      if (result.success) {
        if (result.info) {
          setPhrases(result.info!)
        } else {
          setPhrases([])
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    } else {
      setErrorDialog(result.message!)
      setOpenDialog(true)
    }
  }

  // 起動時
  useEffect(() => {
    const deviceId = searchParams.get('deviceId') ?? auth.deviceId
    auth.setDeviceId(deviceId)

    const fetchData = async () => {
      const result = await c301.execPhraseGet(deviceId)
      if (result.success) {
        if (result.info) {
          setPhrases(result.info!)
        }
      } else {
        setErrorDialog(result.message!)
        setOpenDialog(true)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // ダイアログクローズ
  const handleDialogClose = () => {
    setErrorDialog('')
    setOpenDialog(false)
  }

  return (
    <>
      {openDialog && (
        <ModalConfirmDialog
          open={openDialog}
          text={errorDialog}
          onClick={() => handleDialogClose()}
        />
      )}
      <Box sx={{ display: 'flex', p: 0 }}>
        <Box sx={{ p: 0, width: '338px', flexShrink: 0 }}>
          <SideMenu />
        </Box>
        <Box sx={{ flexGrow: 1, overflowX: 'auto' }} display="flex" flexDirection="column">
          <Box marginTop={13}>
            <CustomTitle>{translation['label_priority_words']}</CustomTitle>
          </Box>
          <Box
            sx={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 9999,
            }}
          >
            {(c301.loading === loadStatus.LOADING ||
              c302.loading === loadStatus.LOADING ||
              c303.loading === loadStatus.LOADING) && <CircularProgress />}
          </Box>
          <Box>
            <CustomExplain>{translation['message_priority_word_info']}</CustomExplain>
          </Box>
          <Box
            sx={{
              marginTop: '40px',
            }}
          >
            <CustomPaper>
              <Grid container spacing={2}>
                <Grid item lg={6} xl={3.7}>
                  <AddButton title={translation['label_priority_words']} onAdd={phraseAddHandler}>
                    {translation['button_add_new']}
                  </AddButton>
                </Grid>
                <PhraseList items={phrases} onDeletePhrase={phraseDelHandler} />
              </Grid>
            </CustomPaper>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  )
}
